import React from 'react';
import View from 'components/ui/view';
import Cart from 'images/icons/cart.svg?react-svg';
import Button from 'components/ui/button';

export default function SubstitutionsSuccess({ user }) {
  return (
    <div className="substitutions-success">
      <View
        padding={{ top: 'lg', bottom: 'lg' }}
        className="substitutions__container text-center"
      >
        <View margin="md">
          <div className="substitutions__cart-icon-container inline-block">
            <span className="substitutions__success-icon success-icon" />
            <Cart width={45} />
          </div>
          <p>
            Your order has been updated!{user && user.firstname
              ? ` Thanks, ${user.firstname}.`
              : ''}
          </p>
        </View>
        <a href="/tracking">
          <Button primary outline rect>
            Track Your Order
          </Button>
        </a>
      </View>
    </div>
  );
}
